export default prop => global && global.window && global.window[prop];



// WEBPACK FOOTER //
// ./src/Common/isWindowProp/index.js